import { call, put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getServiceIdSelector } from '../../user/selectors'
import { getPcrIdSelector } from '../../home/selectors'
import { IPcr } from '../../pcr/store/pcr.types'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { HomeConstants } from '../../home/store/home.constants'
import { setHasPatient as setHasPatientFlag } from '../store/patientInformation.actions'

export function* setHasPatient() {
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrID: string = yield select(getPcrIdSelector)
  try {
    if (pcrID) {
      const pcrDocsService = new PcrDocsService(serviceId)
      const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
      const hasPatientValue = !!(pcrDoc?.patient && pcrDoc?.patient?.patientInformation)
      yield put(setHasPatientFlag(hasPatientValue))
    }
  } catch (e) {
    yield put(throwPcrException(`setHasPatientSaga() error: ${e}`))
  }
}

export function* setHasPatientSaga() {
  yield takeLatest([HomeConstants.SET_NEW_PCR], performWithMutexHOG, setHasPatient)
}
